import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import {DarkTheme, lightTheme} from './Themes';
import { Design, Develope, DownArrow} from './AllSvgs';
import './MySkillPage.css'


import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'
const Box = styled.div`
background-color: ${props => props.theme.body};
width: 100vw;
height:100vh;
position: relative;
display: flex;
justify-content: space-evenly;
align-items: center;
@media (max-width: 600px) {
    flex-direction: column; /* Change to column direction */
    // justify-content: center; /* Center vertically */
    // text-align:start;
  }


`

const Main = styled.div`
border: 2px solid ${props => props.theme.text};
color: ${props => props.theme.text};
background-color: ${props => props.theme.body};
padding: 2rem;
width: 30vw;
height: 60vh;
z-index:3;
line-height: 1.5;
overflowX: hidden;
cursor: pointer;

font-family: 'Ubuntu Mono',monospace;
display: flex;
flex-direction: column;
justify-content: space-between;

// &:hover{
//     color: ${props => props.theme.body};
//     background-color: ${props => props.theme.text};
// }


@media (max-width: 600px) {
   width:40vw;
   overflow:scroll;
   overflowX: hidden;
   margin:1rem;
   font-size:1.1rem
  }
`

const Title = styled.h2`
display: flex;
justify-content: center;
align-items: center;
font-size: calc(1em + 1vw);

${Main}:hover &{
    &>*{
        fill:${props => props.theme.body};
    }
}

&>*:first-child{
margin-right: 1rem;
}
`

const Description = styled.div`
color: ${props => props.theme.text};
font-size: calc(0.6em + 1vw);
padding: 0.5rem 0;


${Main}:hover &{
   
        // color:${props => props.theme.body};
    
}

strong{
    margin-bottom: 1rem;
    text-transform: uppercase;
}
ul,p{
    margin-left: 2rem;
}
`

const MySkillsPage = () => {
    return (
      <ThemeProvider theme={DarkTheme}>
        <Box>
          {/* <LogoComponent theme='dark' /> */}
          <SocialIcons theme='dark' />
          <PowerButton className='powerBtn' />
          <ParticleComponent theme='dark' />
  
          <Main>
            <Title style={{
                marginTop:"1rem"
            }}>
              Frontend Developer 
            </Title>
            <Description>
              I value creating the user interface and experience, making websites and web applications come to life.
            </Description>
            <Description>
              <strong>Skills</strong>
              <p>
                HTML, CSS, JavaScript, React, Redux, Sass, Bootstrap, Tailwind, etc.
              </p>
            </Description>
            <Description>
              <strong>Tools</strong>
              <p>
                VSCode, Git, Codepen, Figma, etc.
              </p>
            </Description>
          </Main>
  
          <Main>
            <Title>
              Blockend Developer
            </Title>
            <Description>
              I focus on server-side development, writing smart-contracts in solidity, testing and creating APIs, and managing databases.
            </Description>
            <Description>
              <strong>Skills</strong>
              <p>
                Node.js, Express.js, PostgreSQL,SQL, MongoDB, Prisma, Graphql, REST APIS <br/>
                Solidity, Ether.js, Web.js, Hardhat, Ganache etc.
              </p>
            </Description>
            <Description>
              <strong>Tools</strong>
              <p>
                Postman, Remix, Alchemy, Infura etc.
              </p>
            </Description>
          </Main>
          <BigTitle text="SKILLS" top="80%" right="30%" />
        </Box>
        
      </ThemeProvider>
    );
  };
  
  export default MySkillsPage;
  
  
  